import { z } from 'zod';

import type { AnswerSource } from '@cfa/pathway-fe-shared/xp';

const SmartAnswersErrorSchema = z.object({
  code: z.enum([
    'CONTENT_BLOCKED',
    'QUESTION_NOT_SUPPORTED',
    'MAXIMUM_TOKENS_EXCEEDED',
    'UNHANDLED_ERROR',
  ]),
  questionClassification: z.enum(['LEGAL_LIABILITY', 'FOOD_SAFETY']).optional(),
});

type ParsedSmartAnswersError = z.output<typeof SmartAnswersErrorSchema>;

const isPolicyBlockedError = (error: ParsedSmartAnswersError): boolean =>
  error.code === 'QUESTION_NOT_SUPPORTED' &&
  (error.questionClassification === 'LEGAL_LIABILITY' ||
    error.questionClassification === 'FOOD_SAFETY');

export type SmartSearchDisplay =
  | { kind: 'answer'; text: string; sources: AnswerSource[] | undefined }
  | { kind: 'questionNotSupported' }
  | { kind: 'noAnswer' };

type SmartResultInput =
  | {
      answer?: string;
      error?: unknown;
      sources?: AnswerSource[];
    }
  | undefined;

export const getSmartSearchDisplay = (
  smart: SmartResultInput,
): SmartSearchDisplay => {
  if (smart?.error != null) {
    const parsed = SmartAnswersErrorSchema.safeParse(smart.error);
    if (parsed.success && isPolicyBlockedError(parsed.data)) {
      return { kind: 'questionNotSupported' };
    }

    return { kind: 'noAnswer' };
  }

  if (smart?.answer) {
    return {
      kind: 'answer',
      text: smart.answer,
      sources: smart.sources,
    };
  }

  return { kind: 'noAnswer' };
};
